export enum OcbRemotePlatformLogTypes {
    CredentialsError = 1,
    TechnicalError = 2,
    InvalidPublicKey = 4,
    InvalidCertificate = 8,
}

export enum OcbEnvironmentLogTypes {
    UnknownACKFileReceived = 1,
    UnknownFileReceived = 2,
    ConnectionFailed = 4,
    AgentShutdownFailure = 8,
    AgentStartupFailure = 16,
    ContactLostWithAgent = 32,
    CommandExpired = 64,
}

export enum OcbFileTransferLogTypes {
    TransferSucceeded = 1,
    TransferFailed = 2,
    ACKKOFileReceived = 4,
    ACKOKFileReceived = 8,
    NoACKReceived = 16,
    FileAlreadyExistsInTarget = 32,
    ArchivedFileSentByEmail = 64,
    EmptyFileIgnored = 128,
    RealTimeDisconnected = 256,
}
